export default __webpack_public_path__ + "static/help_02_01_2-cb2bb0e87c9781c2a6cb865e11ef3251.png";